import React, { useEffect } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image,
} from "@react-pdf/renderer";
import logo from "assets/img/print-logo-invoice.png";
import Moment from "moment";

const styles = StyleSheet.create({
  viewer: { width: '100%', height: '100vh' },
  page: { padding: 20, fontSize: 10 },
  header: { textAlign: 'center', marginBottom: 10 },
  logo: { width: 150, height: 75, alignSelf: 'center' },
  row: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 5 },
  column: { flexDirection: 'column', width: '50%' },
  bold: { fontWeight: 'bold' },
  border: { marginTop: 10, borderTop: '1px solid black', paddingTop: 5 },
  footer: { textAlign: 'center', fontSize: 8, marginTop: 15 },
  items: { borderBottom: '1px solid black', paddingBottom: 5 },
  description: { width: '25%', textAlign: 'left' },
  headerCell: { fontWeight: 'bold', borderBottom: '1px solid black', paddingBottom: 3 },
  paymentBox: { backgroundColor: 'green', color: 'white', padding: 10, textAlign: 'center', width: '30%', alignSelf: 'flex-end' },
  centeredHeading: { textAlign: 'center', textTransform: 'uppercase', fontWeight: 'bold', marginBottom: 10 },
  detailRow: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 5 },
  detailLabel: { width: '45%', fontWeight: 'bold' },
  detailValue: { width: '45%' }
});

export default function Cost({ data, currency }) {
  useEffect(() => {}, []);
  Moment.locale("en");

  return (
    <>
      <div className="content pdfViewer">
        <PDFViewer style={styles.viewer}>
          <Document title="Cost Report">
            <Page size="A4" style={styles.page} wrap>
              {/* Header Section */}
              <View style={styles.header} fixed>
                <Image style={styles.logo} src={logo} />
              </View>

              {/* Company Details */}
              <View style={styles.row}>
                <View style={styles.column}>
                  <Text style={styles.bold}>Seatrust Shipping Services Limited</Text>
                  <Text>Company ID: 15351542</Text>
                  <Text>137 Broadway, Bexleyheath</Text>
                  <Text>England Kent DA6 7EZ, United Kingdom</Text>
                  <Text>VAT: 457438463</Text>
                  <Text>+44(0)20 81444 180</Text>
                  <Text>ukaccounts@seatrustshipping.com</Text>
                  <Text>https://seatrustshipping.com/</Text>
                </View>
              </View>

              {/* Payments Made Section */}
              <Text style={styles.centeredHeading}>Payments Made</Text>

              {/* Payment Amount Box */}
              <View style={styles.paymentBox}>
                <Text>Amount Paid</Text>
                <Text style={{ fontSize: 14, fontWeight: 'bold' }}>{currency}{data.payment_amount}</Text>
              </View>

              {/* Payment Recipient Details */}
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Payment Date:</Text>
                <Text style={styles.detailValue}> {Moment(data.created_at).format("DD-MM-yyyy")}</Text>
              </View>

              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Reference Number:</Text>
                <Text style={styles.detailValue}>{data.reference_number}</Text>
              </View>
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Paid To:</Text>
                <Text style={styles.detailValue}>{data.paid_to}</Text>
              </View>
              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Payment Mode:</Text>
                <Text style={styles.detailValue}>{data.payment_mode}</Text>
              </View>

              <View style={styles.detailRow}>
                <Text style={styles.detailLabel}>Paid Through:</Text>
                <Text style={styles.detailValue}>Bank Transfer</Text>
              </View>
             
              {/* Paid To Details */}
             <View style={[styles.row,styles.bold, { marginTop: 20 }]}>
                <View style={styles.column}>
                  <Text style={styles.bold}>Paid To:</Text>
                  <Text>Air Menzies International Limited</Text>
                  <Text>5, The Enterprise Centre</Text>
                  <Text>Kelvin Lane, Crawley</Text>
                  <Text>RH10 9PT West Sussex, United Kingdom</Text>
                </View>
              </View>

              {/* Payment Details Table */}
              <Text style={[styles.bold, { marginTop: 20 }]}>Payment for</Text>
              <View style={styles.border}>
                <View style={[styles.row, styles.items]}>
                  <Text style={[styles.description, styles.headerCell]}>Bill Number</Text>
                  <Text style={[styles.description, styles.headerCell]}>Bill Date</Text>
                  <Text style={[styles.description, styles.headerCell]}>Bill Amount</Text>
                  <Text style={[styles.description, styles.headerCell]}>Payment Amount</Text>
                </View>

                <View style={styles.row}>
                  <Text style={styles.description}>{data.id}</Text>
                  <Text style={styles.description}>{Moment(data.payment_date).format("DD/MM/yyyy")}</Text>
                  <Text style={styles.description}>{data.bill_amount}</Text>
                  <Text style={styles.description}>{data.payment_amount}</Text>
                </View>
              </View>
            </Page>
          </Document>
        </PDFViewer>
      </div>
    </>
  );
}
